import { useSelector } from 'react-redux';

import PopupGroupContext from '@r1-frontend/entities/ConnectDomruPopup/context';
import { AuthHeader } from '@r1-frontend/entities/Layout/Header/AuthHeader';
import Hat from '@r1-frontend/entities/Layout/Header/commonComponents/Hat';
import * as ST from '@r1-frontend/entities/Layout/Header/styled';
import { UnauthHeader } from '@r1-frontend/entities/Layout/Header/UnauthHeader';
import { selectHasAuthorization } from '@r1-frontend/entities/stores/auth/selectors/selectAccessToken';

const Header = (): JSX.Element => {
    const hasAuthorization = useSelector(selectHasAuthorization);

    return (
        <ST.HeaderContainer data-test='header' data-auth={hasAuthorization ? 'authorised' : 'unauthorised'} >
            <Hat/>
            {hasAuthorization
                ? <AuthHeader/>
                : <PopupGroupContext showSurvey>
                    <UnauthHeader/>
                </PopupGroupContext>
            }
        </ST.HeaderContainer>
    );
};

export default Header;
